import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { Icon } from 'antd';
import { isMobile } from 'common/helpers';
import FeaturedDetails from './FeaturedDetails';
import FeaturedSlider from './FeaturedSlider';

import { FeaturedHotel as S } from './styles';

class Featured extends React.Component {
  renderBookButton = (hotel) => {
    return (
      <a href={hotel.deeplink} target="blank" >
        <Button>BOOK WITH DISCOUNT</Button>
      </a>
    );
  }
  renderDesc = () => {
    return (
      <div>
        <p className="lead"><span className="label">In high demand!</span> &nbsp; 12 bookings in the last 24 hours</p>
        <p>Centara Grand is the official home of Sellers World Conference speakers, exhibitors, and attendees. The conference venue is an elevator ride away and is an ideal place to host meetings, connect over a meal, or just run into friends at one of the several top-class rooftop bars.</p>
        <p>Overlooking Bangkok&apos;s vibrant cityscape, rooms and suites at the Centara Grand offer space intelligently designed to relax in great comfort. Revel in the city&apos;s energy while enjoying panoramic views. </p>
        <p>We have reserved a limited number of rooms for our attendees which will sell out quickly - we recommend booking early.</p>
      </div>
    );
  }
  renderBenefits = () => {
    return (
      <div className="hotelBenefits">
        <h3>Benefits and Amenities:</h3>
        <div className="benefits">
          <ul className="list">
            <li><Icon type="check" />Stay at the conference venue</li>
            <li><Icon type="check" />5-star rating</li>
            <li><Icon type="check" />3 different room types</li>
            <li><Icon type="check" />Breakfast buffet</li>
            <li><Icon type="check" />Endless options: 9 bars & restaurants on-site</li>
            <li><Icon type="check" />Award-winning Spa Cenvaree & fitness centre</li>
          </ul>
          <ul className="list">
            <li><Icon type="check" />Unbeatable city views</li>
            <li><Icon type="check" /><span>Club benefits including private meeting rooms & World Executive Lounge access<em>*</em></span></li>
            <li><Icon type="check" />SWC attendee discount price</li>
            <li><Icon type="check" />And much, much more!</li>
            <li><p style={{ margin: 0, fontStyle: 'italic' }}><span className="asterisk">*</span> Select rooms only</p></li>
          </ul>
        </div>
      </div>
    );
  }
  renderMobile = (hotel) => {
    return (
      <section id={`hotel-${hotel.id}`}>
        <FeaturedSlider />
        <FeaturedDetails hotel={hotel} />
        {this.renderBookButton(hotel)}
        <p className="note"><span className="asterisk">*</span> Pricing approximate. You will pay in the hotel&apos;s local currency (THB).</p>
        <div className="hotelInfo">
          {this.renderDesc(hotel)}
          {this.renderBenefits(hotel)}
        </div>
        {this.renderBookButton(hotel)}
      </section>
    );
  }
  renderWeb = (hotel) => {
    return (
      <section>
        <FeaturedDetails hotel={hotel} />
        <S.Row>
          <div style={{ paddingRight: 0 }}>
            {this.renderDesc(hotel)}
            {this.renderBenefits()}
            {this.renderBookButton(hotel)}
          </div>
          <FeaturedSlider />
        </S.Row>
      </section>
    );
  }
  render() {
    const {
      hotel,
    } = this.props;
    return (
      <S.Wrapper>
        {isMobile() ? this.renderMobile(hotel) : this.renderWeb(hotel)}
      </S.Wrapper>
    );
  }
}

Featured.propTypes = {
  hotel: PropTypes.object.isRequired,
};

export default Featured;



// WEBPACK FOOTER //
// ./src/containers/Hotel/Featured.js